import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import { Users, Package, Calculator, Briefcase, Car, Calendar, Contact, Landmark, Gift } from 'lucide-react'
import { ROUTES } from '@/utils/constants'
import { useUser } from '@/providers/UserProvider'
import { isManager } from '@/utils/role'

type TabType = 'dispatch' | 'stock' | 'accounting' | 'hr' | 'carStorage' | 'contacts' | 'events' | 'publicServices' | 'giftCards'

interface TabConfig {
  label: string
  icon: React.ReactNode
  path: string
}

const tabConfigs: Record<TabType, TabConfig> = {
  dispatch: {
    label: 'Dispatch',
    icon: <Users className="icon" />,
    path: ROUTES.DISPATCH
  },
  carStorage: {
    label: 'Gardiennage',
    icon: <Car className="icon" />,
    path: ROUTES.CAR_STORAGE
  },
  contacts: {
    label: 'Annuaire',
    icon: <Contact className="icon" />,
    path: ROUTES.CONTACTS
  },
  stock: {
    label: 'Gestion du stock',
    icon: <Package className="icon" />,
    path: ROUTES.STOCK
  },
  accounting: {
    label: 'Comptabilité',
    icon: <Calculator className="icon" />,
    path: ROUTES.ACCOUNTING
  },
  hr: {
    label: 'Ressources Humaines',
    icon: <Briefcase className="icon" />,
    path: ROUTES.HR
  },
  events: {
    label: 'Événements',
    icon: <Calendar className="icon" />,
    path: ROUTES.EVENTS
  },
  publicServices: {
    label: 'Custos SP',
    icon: <Landmark className="icon" />,
    path: ROUTES.PUBLIC_SERVICES
  },
  giftCards: {
    label: 'Gift Cards',
    icon: <Gift className="icon" />,
    path: ROUTES.GIFT_CARDS
  },
}

const MANAGER_ONLY_TABS: TabType[] = ['accounting', 'hr', 'events']

interface NavigationTabsProps {
  currentTab: TabType
  onTabChange: (tab: TabType) => void
}

export const NavigationTabs: React.FC<NavigationTabsProps> = ({ currentTab, onTabChange }) => {
  const location = useLocation()
  const { user } = useUser()

  const visibleTabs = (Object.keys(tabConfigs) as TabType[]).filter((tab) => {
    if (MANAGER_ONLY_TABS.includes(tab)) return isManager(user?.role)
    return true
  })

  return (
    <div className="nav-tabs-modern">
      {visibleTabs.map((tab) => {
        const config = tabConfigs[tab]
        const isActive = currentTab === tab || location.pathname === config.path

        return (
          <Link
            key={tab}
            to={config.path}
            onClick={(e) => {
              e.preventDefault()
              onTabChange(tab)
            }}
            className={`nav-tab-modern ${isActive ? 'active' : ''}`}
          >
            {config.icon}
            <span>{config.label}</span>
          </Link>
        )
      })}
    </div>
  )
}
